module.exports = __webpack_public_path__ + "static/img/MY.8181e2fa.png";